import {omit} from 'lodash'
import React from 'react'
import Text from 'react-text'

function ListItem (props) {
  const {onClick, selected, itemValue} = props
  const selectedClass = selected ? 'selected' : 'selectable'
  return (
    <div
      className={`item ${selectedClass}`}
      onClick={() => onClick && onClick(omit(props, ['key', 'itemValue', 'onClick', 'mapItem']))}
    >
      {itemValue}
    </div>
  )
}

export default function ListBox(props) {
  
  const {
    labelId,
    onClick,
    className = "listbox",
    items = [],
    idProperty = 'id',
    mapItem = ({name}) => name
  } = props

  const listItems = items.map(item => {
    return (
      <ListItem
        onClick={onClick}
        itemValue={mapItem(item)}
        key={item[idProperty]}
        {...item}
      />
    )
  })

  return (
    <div className={className}>
      {labelId && (
        <div className="label">
          <Text id={labelId} />
        </div>
      )}
      <div className="items-wrapper">
        <div className="items-container">
          <div className="items">
            {listItems}
          </div>
        </div>
      </div>
    </div>
  )
}
